"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var getOpacityByLevel = function (props) {
    switch (props.level) {
        case 0: {
            return "0";
        }
        case 1: {
            return "0.05";
        }
        case 2: {
            return "0.07";
        }
        case 3: {
            return "0.08";
        }
        case 4: {
            return "0.09";
        }
        case 6: {
            return "0.11";
        }
        case 8: {
            return "0.12";
        }
        case 12: {
            return "0.14";
        }
        case 16: {
            return "0.15";
        }
        case 24: {
            return "0.16";
        }
        default: {
            return "0";
        }
    }
};
exports.Overlay = styled_components_1.default.div.attrs({
    className: "Overlay",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #ffffff; // ! OVERLAY\n  opacity: ", ";\n  transition: opacity 150ms;\n  z-index: ", ";\n  overflow: hidden;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: #ffffff; // ! OVERLAY\n  opacity: ", ";\n  transition: opacity 150ms;\n  z-index: ", ";\n  overflow: hidden;\n  pointer-events: none;\n"])), getOpacityByLevel, function (props) { return props.zIndex || "auto"; });
var templateObject_1;
